import { render, staticRenderFns } from "./YoutubeIframe.vue?vue&type=template&id=2afad9f7&scoped=true"
import script from "./YoutubeIframe.vue?vue&type=script&lang=js"
export * from "./YoutubeIframe.vue?vue&type=script&lang=js"
import style0 from "./YoutubeIframe.vue?vue&type=style&index=0&id=2afad9f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afad9f7",
  null
  
)

export default component.exports